import React from 'react';
import { SectionHeader } from '../components/shared/SectionHeader';
import { AnimatedSection } from '../components/shared/AnimatedSection';
import { GraduationCap, Heart, Leaf } from 'lucide-react';
export function CSRPage() {
  return <div className="min-h-screen pt-20" data-id="element-353">
      <SectionHeader title="Corporate Social Responsibility" subtitle="Committed to making a positive impact in our communities" data-id="element-354" />

      <section className="py-16 sm:py-20 md:py-24" data-id="element-355">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-356">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12" data-id="element-357">
            <AnimatedSection data-id="element-358">
              <div className="bg-white border border-border p-8 h-full" data-id="element-359">
                <div className="w-16 h-16 bg-blue-50 flex items-center justify-center mb-6" data-id="element-360">
                  <GraduationCap size={32} className="text-blue-600" strokeWidth={1.5} data-id="element-361" />
                </div>
                <h3 className="font-heading font-semibold text-2xl text-charcoal mb-4" data-id="element-362">
                  Youth Empowerment
                </h3>
                <ul className="space-y-3 text-stone" data-id="element-363">
                  <li data-id="element-364">• Scholarships for students</li>
                  <li data-id="element-365">• Vocational training programs</li>
                  <li data-id="element-366">• Entrepreneurship support</li>
                  <li data-id="element-367">• Job placement assistance</li>
                </ul>
              </div>
            </AnimatedSection>

            <AnimatedSection data-id="element-368">
              <div className="bg-white border border-border p-8 h-full" data-id="element-369">
                <div className="w-16 h-16 bg-red-50 flex items-center justify-center mb-6" data-id="element-370">
                  <Heart size={32} className="text-red-600" strokeWidth={1.5} data-id="element-371" />
                </div>
                <h3 className="font-heading font-semibold text-2xl text-charcoal mb-4" data-id="element-372">
                  Community Development
                </h3>
                <ul className="space-y-3 text-stone" data-id="element-373">
                  <li data-id="element-374">• School infrastructure support</li>
                  <li data-id="element-375">• Healthcare initiatives</li>
                  <li data-id="element-376">• Clean water projects</li>
                  <li data-id="element-377">• Affordable housing programs</li>
                </ul>
              </div>
            </AnimatedSection>

            <AnimatedSection data-id="element-378">
              <div className="bg-white border border-border p-8 h-full" data-id="element-379">
                <div className="w-16 h-16 bg-green-50 flex items-center justify-center mb-6" data-id="element-380">
                  <Leaf size={32} className="text-green-600" strokeWidth={1.5} data-id="element-381" />
                </div>
                <h3 className="font-heading font-semibold text-2xl text-charcoal mb-4" data-id="element-382">
                  Environmental Sustainability
                </h3>
                <ul className="space-y-3 text-stone" data-id="element-383">
                  <li data-id="element-384">• Cleanup campaigns</li>
                  <li data-id="element-385">• Tree planting initiatives</li>
                  <li data-id="element-386">• Green construction practices</li>
                  <li data-id="element-387">• Renewable energy support</li>
                </ul>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>
    </div>;
}